<script setup lang="ts">
import { dataMaskaTokens } from '~/utils/formUtils'

const props = withDefaults(
  defineProps<{
    modelValue: string
    name: string
    label: string
    type: string
    placeholder?: string
    disableField?: boolean
    autocomplete?: string
    mask?: string
  }>(),
  {
    placeholder: undefined,
    disableField: false,
    autocomplete: undefined,
    mask: undefined,
  }
)

defineEmits<{ (e: 'update:modelValue', value: string): void }>()

// Type
const showPassword = ref(false)
const inputType = computed(() => {
  if (props.type === 'password') {
    return showPassword.value ? 'text' : 'password'
  }
  return props.type
})
</script>

<template>
  <McField v-slot="{ invalid }" :name="name">
    <fieldset class="flex w-full flex-col gap-2 self-end" :class="{ 'opacity-50': disableField }">
      <legend class="mb-3 min-h-[15px] text-2xs text-mcd-secondaryDarkGrey">
        {{ modelValue ? label : '' }}
      </legend>
      <div class="relative flex w-full flex-1 justify-end">
        <input
          :id="name"
          v-maska
          :data-maska="mask"
          :data-maska-tokens="dataMaskaTokens"
          :value="modelValue"
          :name="name"
          class="w-full border-b-2 text-mcd-black outline-none"
          :class="{ 'border-mcd-secondaryLightGrey': !invalid, 'border-mcd-red': invalid }"
          :type="inputType"
          :placeholder="placeholder"
          :disabled="disableField"
          :autocomplete="autocomplete"
          @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
        />

        <i
          v-if="type == 'password'"
          class="pi absolute right-0 cursor-pointer"
          :class="showPassword ? 'pi-eye' : 'pi-eye-slash'"
          @click="showPassword = !showPassword"
        />
      </div>
    </fieldset>
  </McField>
</template>
